<div class="main-page">
  <router-outlet>
  </router-outlet>
</div>
<ngx-ui-loader bgsColor="#017AC2" bgsType="ball-scale-multiple"></ngx-ui-loader>
